// extracted by mini-css-extract-plugin
export var contentBackground = "_404-module--contentBackground--6BsME";
export var contentInner = "_404-module--contentInner--+W47s";
export var contentText = "_404-module--contentText--G1isu";
export var slideUp = "_404-module--slideUp--7iX1N";
export var slideUpLarge = "_404-module--slideUpLarge--zp50U";